import React, { useEffect } from 'react'
import AboutService from '../Component/Service/AboutService'
import WebService from '../Component/Service/WebService'
import FeatureService from '../Component/Service/FeatureService'
import KeyStepService from '../Component/Service/KeyStepService'
import ContactUs from '../Component/Service/ContactUs'
import Service1 from '../Component/Service/Service'
import CoreService from '../Component/Service/CoreService'
import { useParams } from 'react-router-dom'
import DesignService from '../Component/Service/DesignService'
import DevelopService from '../Component/Service/DevelopService'
import OurCoreService from '../Component/Service/OurCoreService'
import Experience from '../Component/Service/Experience'

const Service = () => {
  const { category } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
    <Service1 />  
    <AboutService />
    {category === "design" ? <DesignService/> : ""}
    {category === 'responsiveDesign' ? <DevelopService /> : ""}
    {category === "responsiveDesign" ? <Experience /> : ""}
    <WebService />
    {category !== "design" ? category !== 'responsiveDesign' ? <FeatureService /> : "" : ""}
    {category === 'design' ? <OurCoreService /> : ""}
    {category !== 'design' && category !== 'responsiveDesign' ? <KeyStepService /> : ""}
    <CoreService />
    <ContactUs />
    </>
  )
}

export default Service